import { chunk as arrayChunk } from 'lodash-es';
import { report, reportSendBeacon } from '../../api';
import { ReportAction } from '../../api/operations';

// 上报缓存队列
let actionBuffer: Array<ReportAction> = [];
// 上报interval
let uploadInterval: number;

// 批量上报时间间隔
const UPLOAD_INTERVAL = 10000;
// 上报数量限制
const UPLOAD_LIMIT = 10;
// 重新上传次数
const RETRY_TIMES = 3;
let retryCount = 0;


/**
 * 添加上报行为
 * @param action 上报行为
 */
export const addAction = (action: ReportAction) => {
  actionBuffer.push(action);
};

/**
 * 清空上报缓存
 */
const clearActions = () => {
  actionBuffer = [];
};

/**
 * 上报到后端
 * @returns
 */
const uploadActions = () => {
  if (!actionBuffer.length) return;
  const chunks = arrayChunk(actionBuffer, UPLOAD_LIMIT);
  clearActions();
  chunks.forEach((chunk) => {
    uploadActionsChunk(chunk);
  });
};

/**
 * 上报事件分片
 * @param chunk 事件分片
 */
const uploadActionsChunk = async (chunk: Array<ReportAction>) => {
  try {
    const res: any = await report({
      params: { action_list: chunk },
    });
    uploadComplete(!!res.report, chunk);
  } catch (error) {
    uploadComplete(false, chunk);
  }
};

/**
 * 上报完成处理
 * @param isSuccess 是否成功
 */
const uploadComplete = (isSuccess: boolean, chunk: Array<ReportAction>) => {
  // 上报成功：重试次数置0
  if (isSuccess) {
    retryCount = 0;
    return;
  }
  // 上报不成功：RETRY_TIMES次以内重新上传
  retryCount += 1;
  if (retryCount <= RETRY_TIMES) {
    actionBuffer.push(...chunk);
  }
};

/**
 * 开启间隔上报
 * @param interval 间隔时间，默认5s
 */
export const startUploadInterval = (interval = UPLOAD_INTERVAL) => {
  uploadInterval = window.setInterval(() => {
    uploadActions();
  }, interval);
};

/**
 * 清除上报间隔
 */
export const clearUploadInterval = () => {
  // 上报存量缓存
  if (actionBuffer.length) {
    const isSended = reportSendBeacon({
      params: { action_list: actionBuffer },
    });
    if (isSended) {
      clearActions();
    } else {
      uploadActions();
    }
  }
  window.clearInterval(uploadInterval);
};
